import React from 'react';
import { GenericTableColumn } from '@ui-components/Table/GenericTable';
import { GenericTag } from '@ui-components/Tag/GenericTag';
import type { BackboneService } from './backbone.types';
import { GLOBAL_BW, fmtBw } from './backbone.data';
import { TagsWithPopover } from '../Shared/TagsWithPopover/TagsWithPopover';
import { RichTagsWithPopover } from '../Shared/TagsWithPopover/RichTagsWithPopover';

export type { BackboneService } from './backbone.types';

/**
 * Column definitions for the backbone list table (MainBackbone).
 */
export const backboneListColumns: GenericTableColumn<BackboneService>[] = [
    {
        header: 'Backbone ID',
        renderCell: (bb) => (
            <span className="font-medium underline text-semantic-text-brand">
                {bb.subscriptionId ?? bb.id}
            </span>
        ),
    },
    {
        header: 'Name',
        accessor: 'name',
    },
    {
        header: 'Status',
        renderCell: (bb) => (
            <GenericTag label={bb.status} variant="success" size="small" />
        ),
    },
    {
        header: 'VRFs',
        renderCell: (bb) => (
            <TagsWithPopover tags={bb.vrfs} maxVisible={1} />
        ),
    },
    {
        header: 'Tags',
        renderCell: (bb) => {
            // Prefer the rich tags from the Tags Manager pivot so the chip
            // strip carries color + category. Fall back to the legacy
            // string list (`tagsLegacy`) while the backend rollout is in
            // flight; show "–" when neither source has any entry.
            if (bb.tagsRich != null && bb.tagsRich.length > 0) {
                return (
                    <RichTagsWithPopover
                        tags={bb.tagsRich}
                        maxVisible={1}
                        triggerSingleRow
                    />
                );
            }
            if (bb.tags == null || bb.tags.length === 0) {
                return <span className="text-semantic-text-secondary">–</span>;
            }
            return <TagsWithPopover tags={bb.tags} maxVisible={1} />;
        },
    },
    {
        header: 'Committed',
        renderCell: () => (
            <span className="font-medium text-semantic-text-primary">
                {fmtBw(GLOBAL_BW)}
            </span>
        ),
    },
    {
        header: 'Connectors',
        renderCell: (bb) => (
            <span className="text-sm text-semantic-text-secondary">
                {bb.connectorsCount ?? 0}
            </span>
        ),
    },
];
